module.exports = __webpack_public_path__ + "static/media/gymnase_cours_femme.30793df3.jpg";